import { Percent } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const DiscountsIcon = createNavigationLucideIcon(Percent);
